const lineConfigKeys = ['lineLoginAppBotPrompt', 'lineLoginAppId', 'lineLoginAppLiffId'];
export function retrieveLineConfig({ partner = {}, sponsor = {} }) {
    const hasSponsorSiteConfig = Boolean(sponsor.lineLoginAppId);

    return lineConfigKeys.reduce((obj, key) => {
        const valInSponsor = sponsor[key];
        const valInPartner = partner[key];
        obj[key] = hasSponsorSiteConfig ? valInSponsor : valInPartner;
        return obj;
    }, {});
}
